__turbopack_context__.v({
  "submitButton": "style-module-scss-module__MgDnFG__submitButton",
  "submitLabel": "style-module-scss-module__MgDnFG__submitLabel",
});
